import { mapState } from "vuex";
import axios from "axios";

export default {
    name: "mixinSecao",
    data: () => ({
        secoes: {},
    }),
    computed: {
        ...mapState(["backendUrl", "pgLimit", "usuario"]),
    },
    methods: {
        listarSecoes() {
            return axios
                .post(`${this.backendUrl}produto/secao/listar`, {
                    limit: 9999,
                    offset: 0,
                    busca: null,
                })
                .then((res) => {
                    this.secoes = res.data;
                    this.secoes.lista = this.secoes.lista.filter((v) => {
                        return (
                            v.idsecao !== 1
                        );
                    });
                });
        },
    },
    created() {
        this.listarSecoes();
    },
}